import React, { useContext } from "react";
// Router
import { Link } from "react-router-dom";
// Contexto
import { ConfirmModalContext } from "../../../context/confirmModalContext";
import { ModalContext } from "../../../context/modalContext";
// Componentes
import ComponentTable from "../../generic/ComponentsTable";
import Icon from "../../generic/Icon";
import FormDestino from "./FormDestino";
import TooltipIcon from "../../generic/TooltipIcon";
// Images
import deleteIcon from "../../../assets/delete.png";
import editIcon from "../../../assets/editing.png";
// Utils
import { dateToString } from "../../../utils";

import { Image } from "react-bootstrap";

//obtenDestinoHermana te devuelve el destino actual de la hermana
const TablaDestinos = ({ type, datosHermanas, handlePutDestino, handleDelDestino, obtenDestinoHermana, permisoEdicion, ...props }) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);

  // Ventana de confirmación
  const { confirmModalSetShow, confirmModalSetTitle, confirmModalSetContent, confirmModalSetFunction } = useContext(ConfirmModalContext);

  // Obtiene el usuario en la tabla con la función de redirección
  //042022 arreglado
  const getUsuario = (row) => {
    //console.log('getUsuario tabla destinos')
    //console.log(row)
    let tipo = row?.type === "Monja" ? "hermanas" : "laicos";
    return permisoEdicion ? 
      <Link to={`/${tipo}/${row?.id}`}>{`${row?.name} ${row?.firstSurname} ${row?.secondSurname}`}</Link> : 
      <h4>{row?.name} {row?.firstSurname} {row?.secondSurname}</h4>;
  };

  // Procesa la fecha startdate y la devuelve
  const processStartDate = (row) => {
    //042022 hecho
    let fecha = row.sister?.destinations?.[0]?.startDate
    //console.log(fecha)
    return fecha ? dateToString(fecha) : "No especificado";
  };

  // Procesa la fecha de endDate y la devuelve
  const processEndDate = (row) => {
    let fecha = row.sister?.destinations?.[0]?.endDate
    return fecha ? dateToString(fecha) : "No especificado"
  };

  // Gestiona la acción que se realiza cuando damos en la imagen de editar destino
  const editDestino = (row) => {
      return (
        <>
        {//console.log('editDestino tabla destinos: ')
        }
          {//console.log(row)
          }
          <Icon
            src={editIcon}
            onClick={() => {
              modalSetShow(true, "80%");
              modalSetTitle(`Editar destino`);
              modalSetContent(<FormDestino submissionHandler={handlePutDestino} defaultValues={row} type={type} {...props} />);
            }}
            className="d-flex m-auto"
          />
        </>
      );
  };

  // Gestiona la acción que se realiza cuando damos en la imagen de eliminar destino
  const deleteDestino = (row) => {
    return (
      <Icon
        src={deleteIcon}
        onClick={() => {
            confirmModalSetTitle(`Eliminar destino`);
            confirmModalSetContent(<p> {`¿Está seguro de que quiere eliminar el destino?`} </p>);
            confirmModalSetFunction(() => {
              handleDelDestino(row);
            });
            confirmModalSetShow(true);
        }}
        className="d-flex m-auto"
      />
    );
  };

  const getImagen = (row) => {
    return permisoEdicion ? <Image
      style={{ objectFit: "contain", maxHeight: "60px" }}
      className="img-fluid-detalle"
      variant="top"
      src={
        row.photo ?
          `${process.env.REACT_APP_API_URL}/download/usuarios/${row.id}` 
          : 
          `/images/nun.png`
      }    
      alt="sisterImg"
    /> :
    <Image
      style={{ objectFit: "contain", maxHeight: "120px" }}
      className="img-fluid-detalle"
      variant="top"
      src={
        row.photo ?
          `${process.env.REACT_APP_API_URL}/download/usuarios/${row.id}` 
          : 
          `/images/nun.png`
      }    
      alt="sisterImg"
    />
  }

  return (
    <ComponentTable
      emptyTableComponent={
        <p className="m-2">{`No se han encontrado hermanas`}</p>
      }
      headers={[
        { name: "Foto", value: getImagen },
        { name: "Hermanas", value: getUsuario },
        permisoEdicion && { name: "Fecha inicio", value: processStartDate },
        permisoEdicion &&{ name: "Fecha de fin", value: processEndDate },
        permisoEdicion &&{ name: "Editar", value: editDestino, style: { width: 15 } },
        permisoEdicion &&{ name: "Eliminar", value: deleteDestino, style: { width: 15 } },
      ]}
      rows={datosHermanas.items}
    />
  );
};

export default TablaDestinos;
